import {DataARLedgerModel} from '../../../models/accountsReceivable/data-ar-ledger.model';
import {DataARTransactionItemModel} from '../../../models/accountsReceivable/data-ar-transaction-item.model';
import {DataARPaymentDistribsModel} from '../../../models/accountsReceivable/data-ar-payment-distribs.model';
import { Moment } from 'moment';

export class DataARLedgerListModel extends DataARLedgerModel {
  PostedBy: string;
  RunningBalance: number;
  LocationName: string;
  ClientName: string;
  AmountDue: number;
  PaymentsTotal: number;
  dataARTransactionItemList: DataARTransactionItemModel;
  dataARPaymentDistribs: DataARPaymentDistribsModel[] = [];
  NoteCount: number;
  AmountDuePatient: number;
  AmountDueInsurance: number;
  PaymentsTotalPatient: number;
  PaymentsTotalInsurance: number;
  TotalCreditAdjustments: number;
  TotalDebitAdjustments: number;
  DoctorName: string;
  isShowOnLedger: boolean;
  SortColDec: number;
  sortColPostDate: Date;
  isParentTransaction: boolean;
  explanationForVoid: string;
  ARClaimID: string;
  ARClaimIsActive: boolean = false;
  enumClaimStatusID: string;


  // used on payments page
  ApplyPayment: number;

  // used on debit window
  RefundAmount: number;
  RefundChecked: boolean = true;
  

  ItemDate: Moment;
}
